export default "__VITE_ASSET__A$5zLgkG__"